import React, { useContext } from "react";
import { StyledSwitch } from "../form/Switch/styles";
import styled from "styled-components";
import { useLocalStorageState } from "../../hooks/useLocalStorage";
import { UserContext } from "../../contexts/UserContext";
import { REGIONS } from "../../config/apiUrls";
import { PREFERRED_API_REGION_KEY } from "../../config/preferredApiRegion";

const StyledDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  margin-bottom: 20px;
  font-weight: 600;
  opacity: ${(props) => (props.disabled ? 0.6 : 1)};
`;

const StyledP = styled.p`
  font-size: 16px;
  font-weight: 500;
  padding-bottom: 5px;
  color: ${(props) => props.theme.$primary};
`;

const HoverableSwitch = styled(StyledSwitch)`
  .switch-label,
  .switch-switch,
  .switch-inner,
  .switch-checkbox {
    cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  }
`;

const RegionOption = styled.span`
  font-weight: ${(props) => (props.selected ? 700 : 500)};
  color: ${(props) =>
    props.selected ? props.theme.$primary : props.theme["$text-color"]};
`;

export default function DataCenterSwitch() {
  const [region, setRegion] = useLocalStorageState(
    PREFERRED_API_REGION_KEY,
    REGIONS.OUS,
  );
  const { allowedRegions = [] } = useContext(UserContext);
  const canSwitch = allowedRegions.length > 1;
  const isUsa = region === REGIONS.USA;

  const tooltip = canSwitch
    ? undefined
    : allowedRegions.length === 1
    ? `Your role only has access to ${allowedRegions[0]}`
    : "Loading permissions...";

  const handleOnChange = () => {
    if (!canSwitch) return;
    setRegion(isUsa ? REGIONS.OUS : REGIONS.USA);
    window.location.reload();
  };

  return (
    <div>
      <StyledP>Select the Data Center</StyledP>
      <StyledDiv onClick={handleOnChange} disabled={!canSwitch} title={tooltip}>
        <RegionOption selected={!isUsa}>OUS</RegionOption>
        <HoverableSwitch disabled={!canSwitch}>
          <input
            type="checkbox"
            name="data-center"
            onChange={handleOnChange}
            className="switch-checkbox"
            checked={isUsa}
            disabled={!canSwitch}
          />
          <label className="switch-label" htmlFor="data-center">
            <span className="switch-inner" />
            <span className="switch-switch" />
          </label>
        </HoverableSwitch>
        <RegionOption selected={isUsa}>USA</RegionOption>
      </StyledDiv>
    </div>
  );
}
